import { INIT_SRCM_COLLECTION } from "../constants";

export default function initSrcmCollection(collection, apiParams) {
  return {
    type: INIT_SRCM_COLLECTION,
    collection,
    apiParams,
  };
}
